import { render, staticRenderFns } from "./MortgageSimulator.vue?vue&type=template&id=2126d209&"
import script from "./MortgageSimulator.vue?vue&type=script&lang=ts&"
export * from "./MortgageSimulator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports